import React, { useState } from 'react';
import { loadTossPayments } from '@tosspayments/tosspayments-sdk';
import { track } from '../analytics';

const TOSS_MODE = (process.env.REACT_APP_TOSS_MODE || 'test').toLowerCase();
const TOSS_CLIENT_KEY = (
  TOSS_MODE === 'live'
    ? process.env.REACT_APP_TOSS_LIVE_CLIENT_KEY
    : process.env.REACT_APP_TOSS_TEST_CLIENT_KEY || process.env.REACT_APP_TOSS_CLIENT_KEY
) || '';

export default function SubscriptionModal({ userId, darkMode, onClose, onSuccess }) {
  const [step, setStep] = useState('intro'); // intro | loading | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleRegisterCard = async () => {
    setStep('loading');
    setErrorMsg('');
    track("subscription_started");

    try {
      const tossPayments = await loadTossPayments(TOSS_CLIENT_KEY);
      const payment = tossPayments.payment({ customerKey: userId });

      sessionStorage.setItem('findish_billing_uid', userId);

      await payment.requestBillingAuth({
        method: 'CARD',
        successUrl: `${window.location.origin}/billing/success`,
        failUrl: `${window.location.origin}/billing/fail`,
      });
      // 리다이렉트 방식 — 이 아래 코드는 실행 안 됨
    } catch (err) {
      setErrorMsg(err.message || '카드 등록 중 오류가 발생했습니다.');
      setStep('error');
      track("subscription_failed", { reason: err.message || 'sdk error', stage: "toss_sdk" });
    }
  };

  const bg = darkMode ? '#1a1a1a' : '#fff';
  const fg = darkMode ? '#f0f0f0' : '#111';
  const border = darkMode ? '#333' : '#e0e0e0';

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
    }} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={{
        background: bg, color: fg, borderRadius: 16, padding: '36px 32px',
        width: 360, maxWidth: '90vw', border: `1px solid ${border}`,
        boxShadow: '0 8px 40px rgba(0,0,0,0.3)',
      }}>
        {step === 'intro' && (
          <>
            <div style={{ fontSize: 28, marginBottom: 8 }}>🍳</div>
            <h2 style={{ margin: '0 0 8px', fontSize: 20 }}>Findish Premium</h2>
            <p style={{ margin: '0 0 24px', fontSize: 14, opacity: 0.7, lineHeight: 1.6 }}>
              7일 무료체험 후 월 4,900원<br />
              언제든 해지 가능 · 자동 갱신
            </p>
            <ul style={{ margin: '0 0 28px', padding: '0 0 0 18px', fontSize: 14, lineHeight: 2, opacity: 0.85 }}>
              <li>레시피 전체 열람</li>
              <li>북마크 무제한</li>
              <li>MY NOTE</li>
              <li>태그 검색</li>
            </ul>
            <button onClick={handleRegisterCard} style={{
              width: '100%', padding: '14px', borderRadius: 10, border: 'none',
              background: '#3182f6', color: '#fff', fontSize: 15, fontWeight: 600,
              cursor: 'pointer', marginBottom: 10,
            }}>
              7일 무료로 시작하기
            </button>
            <button onClick={onClose} style={{
              width: '100%', padding: '10px', borderRadius: 10, border: `1px solid ${border}`,
              background: 'transparent', color: fg, fontSize: 14, cursor: 'pointer',
            }}>
              닫기
            </button>
          </>
        )}

        {step === 'loading' && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 36, marginBottom: 16 }}>⏳</div>
            <p style={{ margin: 0, fontSize: 15 }}>Toss 카드 등록 화면으로 이동 중...</p>
          </div>
        )}

        {step === 'error' && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 36, marginBottom: 16 }}>❌</div>
            <p style={{ margin: '0 0 16px', fontSize: 14, color: '#e53e3e' }}>{errorMsg}</p>
            <button onClick={() => setStep('intro')} style={{
              width: '100%', padding: '14px', borderRadius: 10, border: 'none',
              background: '#3182f6', color: '#fff', fontSize: 15, cursor: 'pointer',
            }}>
              다시 시도
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
